import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { InlineTooltipComponent } from '@frontend/sports/tooltip-feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { EpcotConfigService } from '../../common/epcot-config.service';

@Component({
    selector: 'ms-tree-option',
    templateUrl: './tree-option.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [IconCustomComponent, NativePriceFormatterPipe, InlineTooltipComponent],
})
export class TreeOptionComponent {
    @Input() option: EventOption;
    @Input() twoThreeWay = true;
    readonly isEpcotEnabled = this.epcotConfigService.isEnabled();

    constructor(private epcotConfigService: EpcotConfigService) {}
    get name(): string {
        return this.twoThreeWay ? this.option.overridenName || this.option.name : this.option.name;
    }
}
